<template>
    <div class="action-item" :class="{active: $store.state.core.featuresStatus.font_size === 1 || $store.state.core.featuresStatus.font_size === 2}" @click="increaseSize">
        <div class="active-action item" v-if="$store.state.core.featuresStatus.font_size > 0">
          <span class="icon-check"></span>
        </div>


        <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                >
                    <div v-html="icons.textSize"></div>
                    <h3>{{$t('bigger text')}}</h3>
                </div>
            </template>
            <span>{{$t('Make the font size larger')}}</span>
        </v-tooltip>

        <v-style v-if="$store.state.core.featuresStatus.font_size === 1">
            body {
                zoom: 120% !important;
            }
            .theme--light.v-application {
                zoom: 84% !important;
            }
            @-moz-document url-prefix() {
                body , p , h1, h2 , h3 , h4, h5, h6, span, a, strong, td, small, th {
                font-size: 1.1em !important;
                }
            }
        </v-style>
        <v-style v-if="$store.state.core.featuresStatus.font_size === 2">
            body {
                zoom: 150% !important;
            }
            .theme--light.v-application {
            zoom: 70% !important;
            }
            @-moz-document url-prefix() {
            body , p , h1, h2 , h3 , h4, h5, h6, span, a, strong, td, small, th {
                    font-size: 1.2em !important;
                }
            }
        </v-style>
        <div class="feature-progress d-flex">
            <div
                    v-for="(i,index) in 2"
                    :key="index"
                    class="item-progress"
                    :class="{primary: i <= $store.state.core.featuresStatus.font_size}"
            >
            </div>
        </div>
    </div>
</template>
<script>
    import {icons} from '../../utils/icons'
    export default {
        name: "font-size",
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            }
        },
        data () {
            return {
                sizeIndex: 0,
                icons
            }
        },
        methods: {
            increaseSize() {
                if (this.$store.state.core.featuresStatus.font_size <2) {
                    this.$store.state.core.featuresStatus.font_size++;
                } else {
                    this.$store.state.core.featuresStatus.font_size = 0;
                }
                if (this.$store.state.core.featuresStatus.font_size === 1) {
                    this.$emit('countAnalytics', this.data._id)
                }
              localStorage.setItem('featuresStatus', JSON.stringify(this.$store.state.core.featuresStatus))
            }
        }
    }
</script>

<style scoped>

</style>
